import React, {Component} from 'react';
import {injectIntl} from 'react-intl';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {PERIOD_TYPES} from 'config/constants/period';

import PeriodDropdown from 'components/period/PeriodDropdown';

import {changePeriod, changePeriodType} from 'modules/period';

/* This container links the Period component with Redux */
export class PeriodDropdownContainer extends Component {

    static propTypes = {
        dispatch:      PropTypes.func.isRequired, // Function to dispatch actions
        dropdownItems: PropTypes.array, // The array with the items to show in the dropdown for types
        value:         PropTypes.number, // The selected date for the dropdown on route
        reduxValue:    PropTypes.number.isRequired, // The selected date for the dropdown on redux
        type:          PropTypes.string, // The date type for the dropdown on route
        reduxType:     PropTypes.string, // The date type for the dropdown on redux
        section:       PropTypes.string.isRequired, // The section where the component is going to take the data
        onChange:      PropTypes.func.isRequired // Listener when the date has been selected
    };

    static defaultProps = {
        reduxType: PERIOD_TYPES.PERIOD_TYPE_MONTH
    };

    /**
     * Change the browser title and set this to handlers
     */
    componentWillMount() {
        const {
            dispatch,
            onChange,
            section,
            value,
            reduxValue,
            type,
            reduxType
        } = this.props;


        if (type !== reduxType) {
            if (type) {
                dispatch(changePeriodType(section, type));
            } else {
                onChange(reduxType);
            }
        }

        const _type = type || reduxType;

        if (value !== reduxValue) {
            if (value) {
                dispatch(changePeriod(section, value));
            } else {
                onChange(_type, reduxValue);
            }
        }

        this.handleSelect = this.handleSelect.bind(this);
        this.handleChangeType = this.handleChangeType.bind(this);
    }

    /**
     * Manage the query params whe they are changing
     */
    componentWillReceiveProps(nextProps) {
        const
            {
                dispatch,
                section,
                value,
                reduxValue,
                type,
                reduxType,
                onChange
            } = this.props;


        if (nextProps.type !== type ||
            nextProps.reduxType !== reduxType ||
            nextProps.section !== section) {

            if (nextProps.type !== nextProps.reduxType) {
                if (nextProps.type) {
                    dispatch(changePeriodType(nextProps.section, nextProps.type));
                } else {
                    onChange(nextProps.reduxType);
                }
            }
        }

        const _type = nextProps.type || nextProps.reduxType;

        if (nextProps.value !== value ||
            nextProps.reduxValue !== reduxValue ||
            nextProps.section !== section) {

            if (nextProps.value !== nextProps.reduxValue) {
                if (nextProps.value) {
                    dispatch(changePeriod(nextProps.section, nextProps.value));
                } else {
                    onChange(_type, nextProps.reduxValue);
                }
            }
        }
    }

    /**
     * Handles when the dropdown has changed for dispatching the change period action
     * @param {number} date The new selection in the dropdown
     */
    handleSelect(date) {
        const {dispatch, section, onChange, type, reduxType} = this.props;
        const retDate = date instanceof Date ? date.getTime() : date;
        const _type = type || reduxType;

        dispatch(changePeriod(section, retDate));

        onChange(_type, retDate);
    }
    handleChangeType(type) {
        const {dispatch, section, onChange} = this.props;

        dispatch(changePeriodType(section, type));

        onChange(type);
    }

    render() {
        const {reduxType, reduxValue, dropdownItems} = this.props;

        return (
            <PeriodDropdown
                dropdownItems={dropdownItems}
                type={reduxType}
                value={reduxValue}
                onChange={this.handleSelect}
                onChangeType={this.handleChangeType}
            />
        );
    }
}

export const mapStateToProps = (state, props) => {
    const {type} = state.period[props.section];

    let reduxValue;

    if (type === PERIOD_TYPES.PERIOD_TYPE_MONTH) {
        reduxValue = state.period[props.section].startDate;
    } else if (type === PERIOD_TYPES.PERIOD_TYPE_DATE) {
        reduxValue = state.period[props.section].date;
    }

    return {
        reduxValue,
        reduxType: type
    };
};

export default injectIntl(connect(mapStateToProps)(PeriodDropdownContainer));



// WEBPACK FOOTER //
// ./src/containers/period/PeriodDropdownContainer.jsx